import { render, staticRenderFns } from "./AccountRegistrationForm.vue?vue&type=template&id=4f7a0f5e"
import script from "./AccountRegistrationForm.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports